"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-cavallo": {
    "3059a833": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "skipSearch": false
    }],
    "cascine": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08a0aa4b": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "44a6bba7": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "efca9540": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "skipSearch": false
    }],
    "collebianco": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6ec00302": [{
      "hkey": "ee4de283",
      "slug": "pian-della-noce",
      "name": "Pian della Noce",
      "primary": true,
      "skipSearch": false
    }],
    "piandellanoce": [{
      "hkey": "ee4de283",
      "slug": "pian-della-noce",
      "name": "Pian della Noce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7531f031": [{
      "hkey": "c432e4e0",
      "slug": "pie-del-sasso",
      "name": "Pie' del Sasso",
      "primary": true,
      "skipSearch": false
    }],
    "piedelsasso-capoluogo": [{
      "hkey": "c432e4e0",
      "slug": "pie-del-sasso",
      "name": "Pie' del Sasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "76e42c43": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "skipSearch": false
    }],
    "selvapiana": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68ad1cb0": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "skipSearch": false
    }],
    "valcaldara": [{
      "hkey": "e4cf0497",
      "slug": "monte-cavallo",
      "name": "Monte Cavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;